<div class="grid-content">
  @for (selectableItem of selectableSessionTemplateList(); track $index) {
    <app-session-template-card
      (click)="onSessionTemplateCardClick(selectableItem)"
      [sessionTemplate]="selectableItem.item"
      [selectable]="true"
      [isSelected]="selectableItem.isSelected"
    ></app-session-template-card>
  }
</div>
